import useAccountStore from 'store/accountStore';
import { roles } from 'constants/permissions';
import TeamSettings from './TeamSettings';
import TeamRestrictionNote from './TeamRestrictionNote';
// import TeamCreationForm from './TeamCreationForm';
import TeamRequestForm from './TeamRequestForm';

const columns = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
];

const TeamPage = () => {
  const { role, availableProfilesCount } = useAccountStore((state) => ({
    role: state.activeAccount.role,
    availableProfilesCount: state.account.profiles.length,
  }));

  if (roles.isTeamUser(role)) {
    // if user is in team mode, show team members
    return <TeamSettings />;
  }

  if (role === roles.user && availableProfilesCount > 1) {
  // eslint-disable-next-line max-len
  // if user is in user mode and is in a team, show that they already participate in a team and suggest to switch to team mode
    return <TeamRestrictionNote />;
  }
  //
  // if (role === roles.user && availableProfilesCount === 1) {
  // eslint-disable-next-line max-len
  // if user is in user mode and not in a team, show that they are not in a team and suggest to create a team
  //   return <TeamCreationForm />;
  // }
  //
  // if (role === roles.guest) {
  //   // if user is in guest mode, suggest to apply for a team
  //   return <TeamRequestForm />;
  // }

  return null;
};

export default TeamPage;
